import { isAuthRequired } from "@/router/routeConfig";
import { getPlatform } from "@/utils/platform";
import { getBaseurl, getMSToken } from "@/utils/url-parse";
import { shouldAuth } from "./identity";
// 认证接口执行找店逻辑
const reenterShop = () => {
  let url = location.href;
  const { pathname, searchParams, search, hash, origin } = new URL(url);
  if (!shouldAuth()) {
    return;
  }
  const queryParams = searchParams;
  // 移除shopId参数、distributorId参数
  ["shopId", "distributorId"].forEach(param => queryParams.delete(param));
  const newSearch = queryParams.toString();
  const newPathname = newSearch ? `${pathname}?` : pathname;
  const newUrl = new URL(newPathname + newSearch + hash, origin);
  url = newUrl.toString();
  // 调认证接口执行找店
  const href = `${getBaseurl()}/api/member/auth?backUrl=${window.encodeURIComponent(url)}`;
  console.log("checkUrl", url, getBaseurl(), href);
  // eslint-disable-next-line no-restricted-syntax
  window.location.href = href;
};

// 检查url中是否有shopId，没有则自动拼接shopId参数，重新进店
const checkUrl = () => {
  const { searchParams, pathname } = new URL(location.href);
  const queryParams = searchParams;
  const shopId = queryParams.get("shopId");
  if (!shopId || shopId === "undefined") {
    reenterShop();
  }
  return;
};

/**
 * 获取url的query参数对象
 * @param url
 * @returns
 */
export function getQueryParams(url: string): Record<string, string> {
  const paramArr = url.slice(url.indexOf("?") + 1).split("&");
  const params: Record<string, string> = {};
  paramArr.map(param => {
    const [key, val] = param.split("=");
    try {
      params[key] = decodeURIComponent(val);
    } catch (e) {
      console.log(e);
    }
  });
  return params;
}
/**
 * 跳转登录页,登录后跳回当前页
 */
export const goToLogin = () => {
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  let url = "";
  const staticQuery: Record<string, string> = getQueryParams(location.href);
  if (getQueryParams(location.href)["distributorId"]) {
    url = `${getBaseurl()}/api/member/auth?backUrl=${window.encodeURIComponent(
      `/#/login?shopId=${staticQuery.shopId}&distributorId=${staticQuery.distributorId}&rdt=1&bU=${window.encodeURIComponent(current)}`,
    )}`;
  } else {
    url = `${getBaseurl()}/api/member/auth?backUrl=${window.encodeURIComponent(
      `/#/login?shopId=${staticQuery.shopId}&rdt=1&bU=${window.encodeURIComponent(current)}`,
    )}`;
  }

  if (staticQuery.shopId && staticQuery.shopId !== "undefined") {
    window["willRedirect"] = true;
    // eslint-disable-next-line no-restricted-syntax
    window.location.href = url;
  } else {
    reenterShop();
  }
};

/**
 * 检查web登录状态，如果需要认证但未登录则跳转登录页
 * @param requireAuth 当前路由是否需要认证
 */
export const checkWebLogin = (requireAuth = false) => {
  // 如果不需要认证，直接返回
  if (!requireAuth) {
    return;
  }

  // 如果是浏览器环境并且未登录（没有token），跳转web登录页
  const { isBrowser } = getPlatform();
  if (!isBrowser || !!getMSToken()) {
    return;
  }

  try {
    const staticQuery: Record<string, string> = getQueryParams(location.href) || {};
    const url = `${getBaseurl()}/#/login_web?shopId=${staticQuery?.shopId}&backUrl=${encodeURIComponent(window.location.href)}`;
    // eslint-disable-next-line no-restricted-syntax
    window.location.replace(url);
  } catch (error) {
    console.log("checkWebLogin error:", error);
  }
};

/**
 * 检查当前路由是否需要认证，如果需要则进行登录检查
 */
export const checkCurrentRouteAuth = () => {
  const currentPath = window.location.pathname;
  const needAuth = isAuthRequired(currentPath);

  if (needAuth) {
    checkWebLogin(true);
  }
};

export { checkUrl, reenterShop };
